<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('patient_list') }}</h2>
      <div :class="$store.state.auth.typeOfUser !== 'pharmacy' ? '' : 'style-button-search'" style="width: 50%">
        <form @submit.prevent="onSearch()" method="post">
          <el-input placeholder="患者名または患者IDを入力して検索してください。" v-model="textSearch" class="input-with-select">
            <el-button style="background-color: #f98ea1" @click="onSearch()" slot="append"><img src="common/img/search.png" width="15" height="15"></el-button>
          </el-input>
        </form>
      </div>
      <p class="mt-3" v-if="!isLoading && isSearch && this.textSearch && patientSearch.length == 0">検索条件に合致する結果が⾒つかりませんでした。</p>
      <p class="mt-3" v-else-if="!isLoading && viewedHistories.length == 0">ワンタイムパスワードが入力されていません。</p>
      <template v-else>
        <div v-if="$store.state.auth.typeOfUser !== 'pharmacy' " class="patients-checkbox-area">
          <label>
            <input type="checkbox" class="checkbox-input" :checked="isChecked" v-model="isChecked" @click="onFilter()"/>
            <span class="checkbox-parts">{{ $t('focus_on_patients_who_can_view') }}</span>
          </label>
        </div>
        <div class="patients-list-table">
          <table>
            <tr>
              <th>{{ $t('name') }}</th>
              <th>患者名</th>
              <th>患者ID</th>
              <th class="w-80">{{ $t('gender') }}</th>
              <th class="w-60">{{ $t('age') }}</th>
              <th class="w-130">{{ $t('last_viewed_date') }}</th>
              <th class="w-130">{{ $t('view_permission') }}</th>
            </tr>
            <tr v-for="(item, index) in pageOfItems" :key="index" @click="viewPatientInfo(item.child_id, item.status, item.event_end_time, item.sharing_with_nanacara)">
              <td>{{ item.name }}</td>
              <td>{{ item.name_for_dr }}</td>
              <td>{{ item.patient_id_for_dr }}</td>
              <td>{{ item.gender === 0 ? $t('male') : item.gender === 1 ? $t('female') : $t('not_identify') }}</td>
              <td>{{ $tc('age_ages', getAge(item.birthday)) }}</td>
              <td>{{ getLastViewed(item.last_viewed) }}</td>
              <td>
                  <img src="common/img/icon_key_open.png" height="25" v-if="item.status" />
                  <img src="common/img/icon_key_lock.png" height="25" v-else />
              </td>
            </tr>
          </table>
        </div>
        <div class="pager-area">
          <Pagination :items="patients" v-on:changePage="changePage" :initialPage="1"/>
        </div>
      </template>
      <b-modal centered id="not-allowed" class="modal-content center" :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
        <div class="modal-inner">
          <p class="modal-ttl-error">{{ $t('browsing_is_not_allowed') }}</p>
          <p class="modal-txt-error mb50" v-html="$t('the_otp_has_not_been_entered_or_the_nanacara_app_has_not_been_set_to_allow_viewing_at_all_times')"></p>
          <div class="modal-btn-area clearfix">
            <div class="btn-base pos-center"><a href="javascript:;" class="modal-close" @click="$bvModal.hide('not-allowed')"><p>{{ $t('ok') }}</p></a></div>
          </div>
        </div>
      </b-modal>
    </div>
    <Spinner :isLoading="isLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { BModal, VBModal, BButton} from 'bootstrap-vue'
import Pagination from '@/js/components/Common/Pagination'
import Spinner from '@/js/components/Spinner'
import moment from 'moment'

export default {
  directives: { BModal, VBModal, BButton },
  components: {
    Pagination,
    BModal,
    VBModal,
    BButton,
    Spinner
  },
  async mounted() {
    this.screenTracking(this.$t('patient_list'))
    if (this.patientErrMsg === 'NotAllowMoveToPatientDetail') {
      this.$bvModal.show("not-allowed")
      await this.$store.dispatch('patient/setErrorMsg','')
    }
    if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) {
      this.isLoading = true
      await this.$store.dispatch('patient/getViewedHistories')
      this.patients = this.$store.state.patient.viewedHistories
      this.isLoading = false
    }
  },
  data() {
    return {
      isChecked: false,
      pageOfItems: [],
      patients: [],
      isLoading: false,
      textSearch: '',
      isSearch: false,
      patientSearch: []
    }
  },
  computed: {
    ...mapState({
      patientErrMsg: state => state.patient.errorMsg,
      viewedHistories: state => state.patient.viewedHistories,
      doctorInfo: state => state.auth.doctorInfo
    }),
    ...mapGetters({
      patientHistoriesFlg: 'auth/patientHistoriesFlg'
    }),
    patient_histories_flg() {
      return this.$store.state.auth.doctorInfo.patient_histories_flg
    }
  },
  watch: {
    async patient_histories_flg() {
      if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) {
        this.isLoading = true
        await this.$store.dispatch('patient/getViewedHistories')
        this.patients = this.$store.state.patient.viewedHistories
        this.isLoading = false
      }
    },
    textSearch () {
      if (!this.textSearch) {
        this.isSearch = false
        this.patients = !this.isChecked ? this.viewedHistories : this.viewedHistories.filter((patient) => patient.status)
      }
    }
  },
  methods: {
    changePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    onFilter() {
      const currentPatients = this.patients
      if (!this.isChecked) this.patients = currentPatients.filter((patient) => patient.status)
      else this.patients = !this.isSearch ? this.viewedHistories : this.patientSearch
    },
    getAge(birthday) {
      return moment().diff(moment(new Date(birthday)), "years")
    },
    getLastViewed(lastViewed) {
      if (lastViewed) {
        const date = lastViewed.split(' ')[0]
        const [year, month, day] = date.split('-')
        return this.$t('year_month_day', { year: year, month: month, day: day})
      }
      return lastViewed
    },
    viewPatientInfo(childId, status, event_end_time, sharing_with_nanacara) {
      let isAllowView = (sharing_with_nanacara === 'alway_share') 
                    || (sharing_with_nanacara === 'share' && moment(new Date(event_end_time)).isSame(moment().format('YYYY-MM-DD'), 'day'))
                    ||  (!sharing_with_nanacara && !event_end_time && status == 1)
      if (isAllowView) {
        this.$router.push({ path: 'patient/' + childId })
        if (this.$store.state.auth.typeOfUser !== 'pharmacy') {
          this.$store.dispatch("patient/drSelectPatient", {
            childId: this.$route.params.childId,
            hospital_master_id: this.doctorInfo.hospital_master_id
          })
        }
      } else { this.$bvModal.show("not-allowed") }
    },
    onSearch() {
      if(!this.textSearch) return
      this.isSearch = true
      this.patientSearch = this.viewedHistories.filter((item) => item.name_for_dr?.toLowerCase().includes(this.textSearch.toLowerCase()) || item.patient_id_for_dr?.toLowerCase().includes(this.textSearch.toLowerCase()))
      this.patients = this.isChecked ? this.patientSearch.filter((patient) => patient.status) : this.patientSearch
    }
  }
};
</script>

<style>
  .el-icon-search{
    width: 100%;
    height: 100%;
  }
  .style-button-search {
    padding-bottom: 30px;
  }
</style>